import React from "react";
import NoDataView from "./NoDataView";
import NoResultsView from "./NoResultsView";

const MissingData = ({
    isFilterUsed,
    entity,
    includeText,
    path,
    clickCallback,
}) => {
    const renderMissingDataView = () => {
        if (isFilterUsed) {
            return <NoResultsView />;
        } else {
            return (
                <NoDataView
                    entity={entity}
                    includeText={includeText || true}
                    path={path || null}
                    clickCallback={clickCallback || null}
                />
            );
        }
    };

    return <>{renderMissingDataView()}</>;
};

export default MissingData;
